export default {
    onlineUsers: state => state.onlineUsers
};